import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Topic from '@/components/Topic'
import Landing from '@/components/Landing'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/topics',
      name: 'Index',
      component: Index
    },
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/topic/:id',
      name: 'Topic',
      component: Topic
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js